import { render, staticRenderFns } from "./LocalizedText.vue?vue&type=template&id=6822d0e4"
import script from "./LocalizedText.vue?vue&type=script&lang=ts"
export * from "./LocalizedText.vue?vue&type=script&lang=ts"
import style0 from "./LocalizedText.vue?vue&type=style&index=0&id=6822d0e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports